export default __webpack_public_path__ + "static/media/affico-white.3bb0f4aa.svg";